import axios from 'axios'

export default {
  find (query) {
    return axios.get('/findsuburb?q=' + query)
  }
}



// WEBPACK FOOTER //
// ./src/api/postcode.js